import { analytics } from "@flare/analytics";

import { BiEventsNames } from "@/services/analytics/bi-event-names";

import { CALCULATOR_PAGE_NAME, CALCULATOR_STEP_KEY } from "./calculator.consts";
import {
  type CostCalculatorAnswerBiEvent,
  type CostCalculatorStorage,
} from "./calculator.types";

export function sendCalculatorAnswerBiEvent({
  key,
  value,
  text,
  type,
}: {
  key: keyof CostCalculatorStorage["answers"];
  text: CostCalculatorAnswerBiEvent["click_text"];
  type: CostCalculatorAnswerBiEvent["click_type"];
  value: CostCalculatorAnswerBiEvent["answer_value"];
}) {
  const biEventData: CostCalculatorAnswerBiEvent = {
    page_name: CALCULATOR_PAGE_NAME,
    current_step_key: CALCULATOR_STEP_KEY,
    answer_key: key,
    answer_value: value,
    click_text: text,
    click_type: type,
  };
  analytics.track(BiEventsNames.WebCostCalculatorClick, biEventData);
}
